import React from 'react';
import { useTranslation } from 'react-i18next';

import Header from '../../components/shared/Header/Header';

import TrackerTabs from './TrackerTabs';

const TrackerNew = ({ tab }) => {
  const { t } = useTranslation('common');

  return (
    <div style={{ display: 'flex', flexDirection: 'column', height: '100vh', overflow: 'hidden' }}>
      <Header title={t('navigation.tracker')} />
      <TrackerTabs tab={tab} />
    </div>
  );
};

export default TrackerNew;
